export const COMMISSIONING_PROCEDURE_ACTIONS = Object.freeze({
  START: "start",
  RESET: "reset",
});
